import request from "../utils/request";

// agent/getSubAgentUserList
export const getSubAgentUserList = (data) => {
    return request({
        url: "/agent/getAgentUserList",
        method: "get",
        params: data,
    });
}

export const deleteSubAccount = (data) => {
    return request({
        url: "/agent/user",
        method: "delete",
        params: data,
    });
}

// agent/user
export const addSubAccount = (data) => {
    return request({
        url: "/agent/user",
        method: "post",
        data: data,
    });
}
